import { lazy, Suspense } from "react";
import { CONFIG } from "@/lib/config";

const Globe = lazy(() => import("./Globe"));

export default function GlobeScene(props) {
    return (
        <Suspense
            fallback={
                <div className="absolute inset-0 flex items-center justify-center" data-testid="globe-fallback">
                    <div className="w-60 h-60 sm:w-72 sm:h-72 rounded-full border border-vera-blue/25 border-dashed animate-spin-slow" />
                    <img src={CONFIG.LOGO} alt="VERA" className="absolute w-24 sm:w-28 object-contain mask-fade-circle" />
                </div>
            }
        >
            <Globe {...props} />
        </Suspense>
    );
}
